import { GameActions, IGameLoadData } from 'State/Game/GameActions';
import Game from 'Game';
import { isFacebook, isNative } from 'Utility/Platform';
import { UIActions } from 'State/UI/UIActions';
import { PopupID } from 'State/UI/PopupID';
import { PlayerActions } from 'State/Player/PlayerActions';
import { ConnectFbSplashScreen } from 'System/UI/Menu/ConnectFbSplashScreen';
import { AuthPlatform } from '@sgorg/mobile-dev-tools';
import { PlatformActions } from 'State/Game/PlatformActions';
import { handleIAP } from 'System/Preload/HandleIAP';
import { runAsyncPreloadTasks } from './RunAsyncPreloadTasks';
import { handleCrossPromo } from 'System/Preload/HandleCrossPromo';
import { AsyncActionStatus } from 'State/AsyncAction';
import { DataConflictActions } from 'State/Game/DataConflictActions';
import { report } from 'report';

export async function startGame(gameLoadedState: IGameLoadData) {
    GameActions.setLoadedData(gameLoadedState);

    Game.player.data.start();

    await handleIAP();
    // if (!Game.store.getState().playerState.gdprCompliance && isNative()) {
    //     UIActions.showPopup(PopupID.GDPR_POPUP, {});
    //     await Game.store.waitFor(PlayerActions.agreeWithTerms);
    // }

    // if (ConnectFbSplashScreen.shouldShow(Game.store.getState())) {
    //     UIActions.showPopup(PopupID.CONNECT_FB_SPLASH_SCREEN, {});
    //     await Game.store.waitFor(
    //         UIActions.hidePopup,
    //         action => action.payload.popupID === PopupID.CONNECT_FB_SPLASH_SCREEN
    //     );
    // }

    // Silent sign in
    // if (isNative()) {
    //     const platform = Game.sdk.isFacebookConnected() ? AuthPlatform.Facebook : AuthPlatform.Native;
    //     Game.store.dispatch(PlatformActions.signIn(platform, true));
    // } else if (isFacebook()) {
    //     if (Game.store.getState().gbcStatus !== AsyncActionStatus.COMPLETE) {
    //         await Game.store.waitFor(GameActions.connectedToGBC);
    //     }

    //     PlayerActions.setFacebookUserId(Game.sdk.getUserId());
    //     const state = Game.store.getState();
    //     const isDataConflictRestoreInProgress = state.dataConflict?.status === AsyncActionStatus.IN_PROGRESS;
    //     if (isDataConflictRestoreInProgress) {
    //         await Game.store.waitFor(DataConflictActions.resolveConflicts);
    //     }
    // }

    // handleCrossPromo().catch(e => {
    //     report('Failed to init cross promo', {
    //         once: true,
    //         sampleRate: 0.1,
    //         error: e,
    //     });
    // });

    GameActions.gameLoaded();

    // Asynchronous tasks - do not await.
    runAsyncPreloadTasks();
}
